import { render } from "./CardFacebookAd.vue?vue&type=template&id=477ae054&scoped=true"
import script from "./CardFacebookAd.vue?vue&type=script&lang=js"
export * from "./CardFacebookAd.vue?vue&type=script&lang=js"

import "./CardFacebookAd.vue?vue&type=style&index=0&id=477ae054&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-477ae054"

export default script